<div class="login mat-typography noselect" fxFill>
  <mat-card
    appearance="outlined"
    fxLayout="column"
    fxFlex="380px"
    fxFlex.xs="100%"
    fxLayoutAlign=" stretch"
    class="mat-elevation-z13"
  >
    <mat-toolbar color="primary" class="mat-elevation-z3">
      <mat-icon aria-hidden="true">person</mat-icon>
      <span i18n>Login</span></mat-toolbar
    >
    <mat-card-content>
      <form
        name="form"
        (ngSubmit)="f.form.valid && login()"
        #f="ngForm"
        novalidate
        fxLayout="column"
        fxLayoutAlign="space-evenly stretch"
      >
        <mat-form-field>
          <input
            matInput
            i18n-placeholder
            placeholder="Username"
            name="username"
            [(ngModel)]="model.username"
            #username="ngModel"
            required
          />
          <mat-icon class="form-icon" matSuffix>verified_user</mat-icon>
          <mat-error *ngIf="!username.valid" i18n
            >Username is mandatory</mat-error
          >
        </mat-form-field>
        <mat-form-field>
          <input
            matInput
            i18n-placeholder
            placeholder="Password"
            type="password"
            class="form-control"
            name="password"
            [(ngModel)]="model.password"
            #password="ngModel"
            required
          />
          <mat-icon class="form-icon" matSuffix>vpn_key</mat-icon>
          <mat-error *ngIf="!password.valid" i18n
            >Password is mandatory</mat-error
          >
        </mat-form-field>
        <p *ngIf="allowSelfRegistration">
          <ng-container i18n>New user</ng-container>?
          <a *ngIf="standAlone" routerLink="/register" i18n>Register here</a>
          <a *ngIf="!standAlone" (click)="registerRequested.emit()" i18n
            >Register here</a
          >.
        </p>
        <div fxLayout="row" fxLayoutAlign="center center">
          <button mat-raised-button color="primary" [disabled]="loading" i18n>
            Login
          </button>
          <mat-spinner diameter="32" *ngIf="loading"></mat-spinner>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer *ngIf="error">
      <div class="warn" i18n>Invalid username or password</div>
    </mat-card-footer>
  </mat-card>
</div>
